import { render, staticRenderFns } from "./PopupRiskInfoBsgs3.vue?vue&type=template&id=eb1f9f72&scoped=true&"
import script from "./PopupRiskInfoBsgs3.vue?vue&type=script&lang=js&"
export * from "./PopupRiskInfoBsgs3.vue?vue&type=script&lang=js&"
import style0 from "./PopupRiskInfoBsgs3.vue?vue&type=style&index=0&id=eb1f9f72&prod&lang=scss&scoped=true&"
import style1 from "./PopupRiskInfoBsgs3.vue?vue&type=style&index=1&id=eb1f9f72&prod&lang=css&"
import style2 from "./PopupRiskInfoBsgs3.vue?vue&type=style&index=2&id=eb1f9f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1f9f72",
  null
  
)

export default component.exports